import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { ShopSearchPageProps } from './components/ShopSearchPageContent';

const ShopSearchPageContent = lazy(
  () => import('./components/ShopSearchPageContent'),
);

export const ShopSearchPage = wrapLazyNavigatorScreen(
  (props: ShopSearchPageProps) => {
    return <ShopSearchPageContent {...props} />;
  },
  {
    headerShown: false,
    animationEnabled: false,
    presentation: 'transparentModal',
  },
);
